/**
 * 格式化货币金额
 * @param {number} amount - 金额
 * @param {Object} options - 配置选项
 * @param {string} [options.currency='USD'] - 货币代码 (例如 'USD', 'EUR')
 * @param {string} [options.locale='en-US'] - 地区设置
 * @param {number} [options.decimals=2] - 小数位数
 * @param {boolean} [options.addCurrencySymbol=true] - 是否添加货币符号
 * @param {number} [options.conversionFactor=1] - 转换因子 (例如，100 表示将分转换为元)
 * @returns {string} 格式化后的金额字符串
 */

export function formatCurrency(amount, options = {}) {
  const { currency = 'USD', locale = 'en-US', decimals = 2, addCurrencySymbol = true, conversionFactor = 1 } = options;

  // 应用转换因子
  const convertedAmount = amount / conversionFactor;

  // 创建 NumberFormat 实例
  const formatter = new Intl.NumberFormat(locale, {
    style: addCurrencySymbol ? 'currency' : 'decimal',
    currency: currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  // 格式化金额
  return formatter.format(convertedAmount);
}
